/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const l = "labels.optional", o = {
  [l]: "(Optional)"
};
export {
  l as labelsOptional,
  o as messages
};
